import React, { useCallback, useMemo } from 'react';
import { SocialUserInfo } from '../profile-views/ProfileViews';

import { gql } from 'urql';
import {
    GetFollowingCollegesForHighSchoolQuery,
    GetFollowingCollegesForHighSchoolQueryVariables,
    GetFollowingCollegesForHighSchoolDocument,
    UnfollowMutation,
    UnfollowMutationVariables,
    UnfollowDocument,
    Espin_Follow_Type_Enum,
} from '../../../generated/spin-graphql';

import { useAuthenticatedMutation, useAuthenticatedQuery } from 'client/hooks';
import { useAppState } from 'client/providers/AppProvider';
import { FollowingIcon } from '../../svg/dashboard/FollowingIcon';
import { HighSchoolFollowCard } from '../follows/HighSchoolFollowCard';

type Props = {
    allFollowers?: SocialUserInfo[];
};

gql`
    query GetFollowingCollegesForHighSchool($highSchoolId: uuid!) {
        espin_follow(
            where: { follow_type: { _eq: high_school_follows_college }, high_school_id: { _eq: $highSchoolId } }
        ) {
            ...HighSchoolFollowCard
        }
    }
`;
export const HighSchoolFollowing: React.FC<Props> = () => {
    const { user } = useAppState();

    const { isReady, data } = useAuthenticatedQuery<
        GetFollowingCollegesForHighSchoolQuery,
        GetFollowingCollegesForHighSchoolQueryVariables
    >(
        {
            query: GetFollowingCollegesForHighSchoolDocument,
            variables: {
                highSchoolId: user?.high_school_profile?.high_school?.id,
            },
            pause: !user,
        },
        ['espin_follow'],
    );

    const [__, unFollow] = useAuthenticatedMutation<UnfollowMutation, UnfollowMutationVariables>(UnfollowDocument);

    const handleUnfollowClicked = useCallback(
        (userId) => {
            unFollow(
                {
                    where: {
                        college_id: { _eq: userId },
                        high_school_id: { _eq: user?.high_school_profile?.high_school?.id },
                        follow_type: { _eq: Espin_Follow_Type_Enum.HighSchoolFollowsCollege },
                    },
                },
                { additionalTypenames: ['espin_follow'] },
            );
        },
        [unFollow, user?.high_school_profile?.high_school?.id],
    );
    const listOfFollows = useMemo(() => data?.espin_follow.map((f) => f?.college.id), [data?.espin_follow]);
    return (
        <>
            {isReady && (
                <div className="follow-container">
                    <HighSchoolFollowCard
                        followers={data.espin_follow}
                        following={listOfFollows}
                        noContentIcon={<FollowingIcon />}
                        noContentLabel={'You are not following anyone yet'}
                        handleFollowButtonClicked={(userId: string) => handleUnfollowClicked(userId)}
                    />
                </div>
            )}
        </>
    );
};
